import React from "react";
import { useMediaQuery } from "react-responsive";
import { Button } from "@speedoc/design-assets";
import useAppDownloadLink from "../../hooks/useAppDownloadLink";
import StarRatings from "react-star-ratings";
import { useApi } from "../../hooks/useApi";
import { GlobalStore } from "../../stores/global";

function DownloadAppV4Desktop({ content }) {
  const { currentCountryCode: countryCode } = GlobalStore.useState(s => s);
  const rating = useApi({ url: `https://itunes.apple.com/lookup?id=1288838601&country=${countryCode}`, type: "post" });
  const stars = rating?.results?.[0]?.averageUserRating ?? 5.0;
  const downloadLink = useAppDownloadLink();

  return (
    <div id="downloadAppV4Desktop">
      <div className="images">
        {content.list.length === 2 && (
          <>
            <img src={content.list[0].media.url} className="image-1" alt="" />
            <img src={content.list[1].media.url} className="image-2" alt="" />
          </>
        )}
      </div>
      <div className="contentContainer">
        <div className="titleTop">{content.title}</div>
        <div className="subtitle">{content.subtitle}</div>
        <div className="rating">
          <div className="rate">{Math.round(stars * 10) / 10}</div>
          <StarRatings
            rating={Math.round(stars * 10) / 10}
            starRatedColor="#e6a34f"
            starEmptyColor="#c8d3d9"
            numberOfStars={1}
            name="rating"
            starDimension="40"
          />
        </div>
        {content.listDesc &&
          content.listDesc.length > 0 &&
          content.listDesc.map((desc, index) => (
            <div className="content" key={index}>
              <img alt="icon" src={desc.image?.url} />
              <div className="contentDesc">
                <div className="titleDesc">{desc.title}</div>
                <div className="description">{desc.content}</div>
              </div>
            </div>
          ))}

        <div className="download">
          {content.downloadText && <div className="text">{content.downloadText}</div>}
          <a href={content.downloadLink || downloadLink}>
            <Button className="button primary">
              <span>{content.downloadButton || "Download the App"}</span>
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
}

function DownloadAppV4Mobile({ content }) {
  const downloadLink = useAppDownloadLink();
  return (
    <div id="downloadAppV4Mobile">
      <div className="container">
        <div className="titleTop">{content.title}</div>
        <div className="subtitle">{content.subtitle}</div>
        <div className="descriptionMobile">{content.descriptionMobile}</div>
        <div className="contentContainer">
          {content.listDesc &&
            content.listDesc.length > 0 &&
            content.listDesc.map((desc, index) => (
              <div className="content" key={index}>
                <img alt="icon" src={desc.image?.url} />
                <div className="titleDesc">{desc.title}</div>
              </div>
            ))}
        </div>
      </div>
      <Button className="btnDownload">
        <a className="button secondary sm" href={downloadLink}>
          <span>{"Download the App"}</span>
        </a>
      </Button>
      <div className="images">
        {content.list.length === 2 && (
          <>
            <img src={content.list[0].media.url} className="image-1" alt="" />
            <img src={content.list[1].media.url} className="image-2" alt="" />
          </>
        )}
      </div>
    </div>
  );
}

export default function DownloadAppV4({ content }) {
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });
  return isMobile ? <DownloadAppV4Mobile content={content} /> : <DownloadAppV4Desktop content={content} />;
}
